import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteCompanySettingsModal = ({
  isOpen,
  onClose,
  onConfirm,
  company,
}) => {
  const bodyMessage = `
    Are you sure you want to delete this company setting?
    <br />
    <strong>${company?.company_name || ""}</strong>
    <br /><br />
    This action cannot be undone.
  `;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Delete"
      bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
      confirmLabel="Delete"
      cancelLabel="Cancel"
    />
  );
};

export default DeleteCompanySettingsModal;
